const fetchProductData = (articleNumber, careStepId) => {
    fetch(`/api/product-data/${articleNumber}/${careStepId}`, {
        method: 'get',
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
        })
        .then((json) => {
            if (json.data) {
                return json.data;
            } else if (json.errors) {
                console.error(json.errors);
            }
        })
        .then((data) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'view_item',
                ecommerce: {
                    items: [data],
                },
            });
        })
        .catch((error) => {
            console.error(error);
        });
};

const articleNumberEl = document.querySelector('.product-header .product-header__articleNumber');

if (articleNumberEl) {
    const articleNumber = articleNumberEl.getAttribute('data-article-number');
    const careStepId = window.__GGCareStepNodeId;

    if (articleNumber && careStepId) {
        fetchProductData(articleNumber, careStepId);
    }
}
